<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
<!--          {{ dataId ? '查看' : '新增' }}工程师信息变更
          <span style="margin-left: 15px;">工号</span>：<span v-if="tenant.engineerCode" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
            tenant.engineerCode }}</span>
          <span v-else class="information"> 待生成</span>-->
          变更单号：<span v-if="tenant.changeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
            tenant.changeNo }}</span>
          <span v-else class="information"> 待生成</span>
          <!-- 变更状态 -->
          <span v-if="!dataId" class="information"> 制单</span>
          <span v-else-if="tenant.changeStat == 1" class="information">制单</span>
          <span v-else-if="tenant.changeStat == 2" class="information">审核中</span>
          <span v-else-if="tenant.changeStat == 5" class="information">已审核</span>
          <span v-else-if="tenant.changeStat == 6" class="information">驳回</span>
          <span v-else-if="tenant.changeStat == 99" class="information">取消</span>
          <span v-else class="information"></span>
        </div>
        <div class="fr">
          <el-button type="primary" plain class="button-sty" @click="submitChange" icon="el-icon-coffee-cup" style="margin-right: 10px;" v-if="changeStat===1&&dataId&&!tenant.processId">提交审核</el-button>
          <el-button type="primary" plain class="button-sty" @click="auditChange" icon="el-icon-coffee-cup" style="margin-right: 10px;" v-if="(changeStat===2)&&dataId&&!tenant.processId">审核通过</el-button>
          <el-button type="primary" plain class="button-sty" @click="rejectChange" icon="el-icon-coffee-cup" style="margin-right: 10px;" v-if="changeStat===2&&dataId&&!tenant.processId">驳回</el-button>
          <el-button type="primary" plain class="button-sty" @click="cancelChange" icon="el-icon-coffee-cup" style="margin-right: 10px;" v-if="(changeStat===1||changeStat===6)&&dataId&&!tenant.processId">取消</el-button>
<!--          <el-button type="primary" plain class="button-sty" @click="vacation" icon="el-icon-coffee-cup">休假
          </el-button>
          <el-button type="primary" plain class="button-sty" @click="dimission" icon="el-icon-folder-delete"
            style="margin-right: 100px;">离职
          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData" v-if="(snEngineerChangeSave||mySnEngineerChangeSave)&&(tenant.changeStat !== 99&&tenant.changeStat !== 2&&tenant.changeStat !== 5)" >保存</el-button>
        </div>
      </div>
      <div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="用户信息" name="first">      <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
                <div class="title first"><b>单据信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <!-- 基础信息 -->

                    <tr>
<!--                      <th>
                      <em class="f-red">*</em>
                    变更单号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="tenant.changeNo" clearable :disabled="true"/>
                    </td>-->
                      <th>
                      <em class="f-red">*</em>
                     变更类型
                    </th>
                    <td>
<!--                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">-->
                      <el-form-item prop="languageId">
                        <el-select v-model="changeType" style="width: 165px;" v-bind:disabled="this.dataId !== null && this.dataId !== ''">
<!--                          <el-option label="新增" :value="1" v-if="this.dataId === null || this.dataId === ''" />-->
                          <el-option label="新增" :value="1" />
                          <el-option label="资料变更" :value="2"/>
                        </el-select>
                      </el-form-item>
                    </td>


                    <th>
                      <em class="f-red">*</em>
                     变更状态
                    </th>
                    <td>
<!--                      <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">-->
                      <el-form-item prop="languageId">
                        <el-select v-model="changeStat" style="width: 165px;" :disabled="true">
                          <el-option label="制单" :value="1"/>
                          <el-option label="审核中" :value="2"/>
                          <el-option label="已审核" :value="5"/>
                          <el-option label="驳回" :value="6" />
                          <el-option label="取消" :value="99"/>
                        </el-select>
                      </el-form-item>
                    </td>
                    </tr>

                  </tbody>
                </table>
              </div>
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        工号
                      </th>
                      <td>
                        <!--<el-input type="text" autocomplete="off" v-model="tenant.engineerCode" :disabled="true" clearable />-->
                        <el-input type="text" autocomplete="off" v-model="tenant.engineerCode" readonly
                                  v-bind:disabled="changeType===1">
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="() => { if (changeType!==1) { showChangeEngineerDialog = true } }"></i>
                        </el-input>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        网点名称
                      </th>
                      <td v-if="this.currentSiteData !== null">
                        <el-input type="text" autocomplete="off" v-model="tenant.siteName" readonly :disabled="true">
                          <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                      </td>
                      <td v-else>
                        <el-input type="text" autocomplete="off" v-model="tenant.siteName" readonly>
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog = true"></i>
                        </el-input>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        类型
                      </th>
                      <td>
                        <el-select v-model="tenant.engineerType" style="width: 165px;">
                          <el-option :value="1" label="自有"></el-option>
                          <el-option :value="2" label="可控"></el-option>
                          <el-option :value="3" label="合约"></el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        姓名
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="tenant.engineerName" clearable />
                      </td>

                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        手机
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="tenant.engineerMobile" @blur="inspection"
                                  clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        在职状态
                      </th>
                      <td>
                        <el-select v-model="tenant.postStat" style="width: 165px;">
                          <el-option label="在职" :value="1" />
                          <el-option label="休假中" :value="3" />
                          <el-option label="离职" :value="9" />
                        </el-select>
                      </td>
                      <th>
                        认证等级
                      </th>
                      <td>
                        <el-select v-model="tenant.authLevel" style="width: 165px;">
                          <el-option label="待认证" :value="1" />
                          <el-option label="初级" :value="3" />
                          <el-option label="中级" :value="5" />
                          <el-option label="高级" :value="7" />
                          <el-option label="资深级" :value="9" />
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        密码
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="tenant.password" clearable />
                      </td>

                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        启用
                      </th>
                      <td>
                        <el-select v-model="tenant.stat" style="width: 165px;">
                          <el-option label="启用" :value="1" />
                          <el-option label="禁用App" :value="2" />
                          <el-option label="禁用" :value="9" />
                        </el-select>
                      </td>
                      <th>
                        经度/纬度
                      </th>
                      <td>
                        <div>
                          <el-input type="text" autocomplete="off" v-model="tenant.longitude" :disabled="true" clearable
                            style="width: 49%!important;" />
                          <el-input type="text" autocomplete="off" v-model="tenant.latitude" :disabled="true" clearable
                            style="width: 49%!important;margin-left:2%" />
                        </div>
                      </td>
                      <th><em class="f-red">*</em>
                        地址
                      </th>
                      <td>
                        <el-cascader :props="areaProps" v-model="areaValues" :clearable="true" @change="handleChange"
                          ref="cascader" :options="areaOption">
                        </el-cascader>
                      </td>
                      <th>
                        详细地址
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="tenant.engineerAddress" clearable />
                      </td>

                    </tr>
                    <tr>
                      <th>创建人</th>
                      <td>{{ tenant.createBy }}</td>
                      <th>创建时间</th>
                      <td>{{ tenant.createTime }}</td>
                    </tr>
                  </tbody>
                </table>
          </div>
          <div class="d-item">
            <div class="title first"><b>补充信息</b></div>
            <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        派单状态
                      </th>
                      <td>
                        <el-select v-model="tenant.limitTakeOrder" style="width: 165px;">
                          <el-option label="正常派单" :value="1" />
                          <el-option label="禁止派单" :value="2" />
                        </el-select>
                      </td>
                      <th>
                        学历
                      </th>
                      <td>
                        <el-select v-model="tenant.educational" style="width: 165px;">
                          <el-option label="未选择" :value="0" />
                          <el-option label="无学历" :value="1" />
                          <el-option label="小学" :value="2" />
                          <el-option label="初中" :value="3" />
                          <el-option label="高中" :value="4" />
                          <el-option label="专科" :value="5" />
                          <el-option label="本科" :value="6" />
                          <el-option label="硕士" :value="7" />
                          <el-option label="博士" :value="8" />
                          <el-option label="其他" :value="9" />

                        </el-select>
                      </td>
                      <th>
                        上岗时间
                      </th>
                      <td>
                        <el-date-picker v-model="tenant.startDate" type="date" placeholder="选择日期">
                        </el-date-picker>
                      </td>
                      <th>
                        有效期止
                      </th>
                      <td>
                        <el-date-picker v-model="tenant.endDate" type="date" placeholder="选择日期">
                        </el-date-picker>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        性别
                      </th>
                      <td>
                        <el-select v-model="tenant.sex" style="width: 165px;">
                          <el-option label="男" :value="1" />
                          <el-option label="女" :value="2" />
                        </el-select>
                      </td>
                      <th>
                        星级
                      </th>
                      <td>
                        <el-select v-model="tenant.starRating" style="width: 165px;">
                          <el-option label="一级" :value="1" />
                          <el-option label="二级" :value="2" />
                          <el-option label="三级" :value="3" />
                          <el-option label="四级" :value="4" />
                          <el-option label="五级" :value="5" />
                        </el-select>
                      </td>
                      <th>
                        销售分润比例
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="tenant.salePercentage" clearable />
                      </td>
                      <th>日工单容量</th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="tenant.orderCapacity" clearable />
                      </td>
                    </tr>
                    <!-- <tr>
                <th>头像</th>
                <td colspan="7">
                  <div class="form_picture">
                    <el-upload style="display:flex"
                               :action="api.uploadFileUrl" :on-remove="handleRemove" list-type="picture-card"
                               :file-list="picList"
                               :on-success="(res,file, fileList) => {handleSuccess(res,file, fileList)}"
                               :limit="1"
                               :auto-upload="true" :headers="headers">
                      <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                  </div>

                </td>
              </tr> -->
                  </tbody>
                </table>
          </div>
          <div class="d-item">
                <div class="title first"><b>保险信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                     投保公司
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="tenant.insureCompany" clearable />

                      </td>
                      <th>
                        保险号
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="tenant.insureNo" clearable />

                      </td>
                      <th>
                        保险到期时间
                      </th>
                      <td>
                        <el-date-picker v-model="tenant.insureEndTime" type="date" placeholder="选择日期">
                        </el-date-picker>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>认证信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>用户图片</th>
                      <td colspan="">
                        <div class="form_picture">
                          <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove1"
                            list-type="picture-card" :file-list="picList1"
                            :on-success="(res, file, fileList) => { handleSuccess1(res, file, fileList) }" :limit="1"
                            :auto-upload="true" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                        </div>

                      </td>
                      <th>身份证正面</th>
                      <td colspan="">
                        <div class="form_picture">
                          <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove2"
                            list-type="picture-card" :file-list="picList2"
                            :on-success="(res, file, fileList) => { handleSuccess2(res, file, fileList) }" :limit="1"
                            :auto-upload="true" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                        </div>

                      </td>
                      <th>身份证反面</th>
                      <td colspan="">
                        <div class="form_picture">
                          <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove3"
                            list-type="picture-card" :file-list="picList3"
                            :on-success="(res, file, fileList) => { handleSuccess3(res, file, fileList) }" :limit="1"
                            :auto-upload="true" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                        </div>

                      </td>
                      <th>资格证书</th>
                      <td colspan="">
                        <div class="form_picture">
                          <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove4"
                            list-type="picture-card" :file-list="picList4"
                            :on-success="(res, file, fileList) => { handleSuccess4(res, file, fileList) }" :limit="1"
                            :auto-upload="true" :headers="headers">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload>
                        </div>

                      </td>
                    </tr>
                    <tr>
                      <th>
                        上岗资格证编号
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="tenant.certificateNo" clearable />
                      </td>
                      <th>
                       身份证号
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="tenant.engineerPid" clearable />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="height: 50px;"></div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="服务品类" name="third">
            <!-- 服务品类 -->
            <div class="d-cont edit-mce-box">

              <div class="d-item">
                <vxe-table
                  :stripe="true"
                  :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '50%' }"
                  :row-config="{height: 30,isHover: true,padding: 0,}"
                  :row-style="{ fontSize: '12px',  }"
                  style="width:50%;"
                  show-overflow
                  row-id="id"
                  :data="tenant.itemCategoryList"
                  :tree-config="{transform: true}"
                  :checkbox-config="{labelField: 'name', checkRowKeys: tenant.selectedItemCategoryIdList}"
                  @checkbox-change="itemCategorySelectChangeEvent"
                  @checkbox-all="itemCategorySelectChangeEvent"
                  v-if="itemCategoryShow"
                >
                  <vxe-column type="checkbox" width="80" tree-node></vxe-column>
                  <vxe-column field="categoryName" title="服务类型"></vxe-column>
                </vxe-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务区域" name="fourth">
            <!-- 服务区域 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <el-form-item>
                  <template>
<!--                    <el-cascader :props="areaProps1" :clearable="true"
                                 @change="handleChange1" ref="cascaderAddr">
                    </el-cascader>
                    <el-button type="primary" class="button-sty btn_zdy" @click="addAreaData">
                      <i class="el-icon-plus"></i>
                      添加服务区域
                    </el-button>-->
                    <el-button style="margin: 5px 0;"
                               type="primary" class="button-sty btn_zdy" @click="handleDeleteList">
                      <i class="el-icon-delete"></i>
                      批量删除
                    </el-button>
                  </template>
                </el-form-item>


                <vxe-table ref="filterTable" height="250"
                           class="table_item pic_item"
                           :column-config="{ resizable: true }"
                           style="width: 56%;"
                           :stripe="true"
                           :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{height: 30,isHover: true,padding: 0,}"
                           :row-style="{ fontSize: '12px',  }"
                           show-overflow
                           :data="tenant.snSiteAreaList"
                           @checkbox-all="areaSelectAll"
                           @checkbox-change="areaSelect"
                >
                  <vxe-column type="checkbox" width="55">
                  </vxe-column>

                  <vxe-column field="areaNamePath" title="省市区地址" width="`100%-115`">
                  </vxe-column>

                  <vxe-column title="操作" width="60">
                    <template #default="{row}">
                      <div @click="handleDelete(row.id)">
                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                    popper-class="tooltip-skin">
                          <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </vxe-column>
                </vxe-table>
                <!--                <el-button type="primary" class="button-sty btn_zdy" @click="showAreaDialog=true">-->
                <!--                  <i class="el-icon-plus"></i>-->
                <!--                  新增-->
                <!--                </el-button>-->
                <!--                <el-table ref="filterTable" border height="350" :data="table_area" class="table_item pic_item"-->
                <!--                          style="width: 95%;"-->
                <!--                          :header-cell-style="{ background: '#F6FAFF',padding: '0',borderTop: '1px solid #eaeaea',fontSize:'12px',color:'#808080'}"-->
                <!--                          :header-row-style="{height:'36px'}"-->
                <!--                          :row-style="{height:'30px',fontSize:'12px', background: '#fff'}">-->
                <!--                  <vxe-column type="selection" width="55">-->
                <!--                  </vxe-column>-->
                <!--                  <vxe-column prop="areaLevel" label="地区" width="600"/>-->

                <!--                  <vxe-column label="操作">-->
                <!--                    <template slot-scope="scope">-->
                <!--                      <div @click="handleDelete2(scope.$index)">-->
                <!--                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"-->
                <!--                                    popper-class="tooltip-skin">-->
                <!--                          <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>-->
                <!--                        </el-tooltip>-->
                <!--                      </div>-->
                <!--                    </template>-->
                <!--                  </vxe-column>-->
                <!--                </el-table>-->
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务类型" name="five">
            <!-- 服务类型 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <vxe-table
                  :stripe="true"
                  :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '50%' }"
                  :row-config="{height: 30,isHover: true,padding: 0,}"
                  :row-style="{ fontSize: '12px',  }"
                  style="width:50%;"
                  show-overflow
                  resizable
                  row-id="id"
                  :data="tenant.serviceTypeList"
                  :tree-config="{transform: true}"
                  :checkbox-config="{labelField: 'name', checkRowKeys: tenant.selectedServiceTypeIdList}"
                  @checkbox-change="serviceTypeSelectChangeEvent"
                  @checkbox-all="serviceTypeSelectChangeEvent"
                  v-if="serviceTypeShow"
                >
                  <vxe-column type="checkbox" width="80" tree-node></vxe-column>
                  <vxe-column field="serviceTypeName" title="服务类型"></vxe-column>
                </vxe-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="服务渠道" name="six">
            <!-- 服务区域 -->
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div>
                  <vxe-table :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }"
                             :row-style="{ fontSize: '12px', }"  style="width:50%;"
                             :checkbox-config="{ labelField: 'name', checkRowKeys: tenant.selectedBuyChannelIdList }"
                             @checkbox-change="buyChannelChangeEvent"
                             @checkbox-all="buyChannelChangeEvent" show-overflow resizable
                             :column-config="{ resizable: true }"
                             :data="tenant.buyChannelList"
                             :tree-config="{transform: true}"
                             row-id="id"
                             v-if="buyChannelShow"
                  >

                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="buyChannelName" title="购买渠道"></vxe-column>
                  </vxe-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
</el-tabs>


      </div>
    </el-form>
    <preconditionDialog v-if="showPreconditionDialog" @commit="commitSelectedRow"
                        :visiable.sync="showPreconditionDialog" multi="true"
    />
    <engineerDialog v-if="showChangeEngineerDialog" @commit="commitSelectedRow2" :visiable.sync="showChangeEngineerDialog" multi="true"
                 :excludeId="dataId" />
    <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList" />
  </div>
</template>
<script>
import preconditionDialog from '@/views/dialogCommon/radioSiteDialog.vue';
import engineerDialog from '@/views/dialogCommon/radioEngineerDialog.vue';
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import store from "@/store";
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import {mapGetters} from "vuex";
import {siteMixins} from "@/mixins/tabChang";

export default {
  mixins: [siteMixins],
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,
    preconditionDialog,
    engineerDialog,
  },
  data() {
    return {
      snEngineerChangeSave : false,
      mySnEngineerChangeSave : false,
      picList1: [],
      picList2: [],
      picList3: [],
      picList4: [],

      picList: [],
      fileList: [],

      itemCategoryShow : true,
      serviceTypeShow : true,
      buyChannelShow :true,

      showPreconditionDialog: false,
      showChangeEngineerDialog : false,

      changeType : 1,
      changeStat : 1,

      img_b: "",
      upload_btn: false, // 是否隐藏上传图片按钮
      radio: '1',
      showEdit: false,
      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      dialogImageUrlList: [],
      dialogVisible: false,
      // 基本信息
      tenant: {

        isNotChangeUpdate : true,

        tenantAttachmentDTOs: [],

        changeType : 1,
        changeNo : null,
        changeStat : 1,
        engineerId : null,
        siteId : null,
        siteName : null,
        engineerType : null,
        engineerCode : null,
        postStat : null,
        authLevel : null,
        engineerName : null,
        engineerMobile : null,
        engineerProvince : null,
        engineerCity : null,
        engineerCounty : null,
        engineerTown : null,
        areaId : null,
        longitude : null,
        latitude : null,
        engineerAddress : null,
        orderCapacity : null,
        password : null,
        stat : null,
        limitTakeOrder : null,
        sex : null,
        educational : null,
        startDate : null,
        endDate : null,
        salePercentage : null,
        starRating : null,
        insureCompany : null,
        insureNo : null,
        insureEndTime : null,
        engineerPic : null,
        engineerPid : null,
        engineerPidPic1 : null,
        engineerPidPic2 : null,
        certificateNo : null,
        certificateNoPic : null,

        snSiteAreaList: [], // 服务区域

        serviceTypeList: [],
        selectedServiceTypeIdList: [], //服务类型
        itemCategoryList: [],
        selectedItemCategoryIdList: [], //网点服务品类
        buyChannelList : [],
        selectedBuyChannelIdList : [] //服务渠道


      },
      showProductCategoryDialog: false,

      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      areaProps1: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad1
      },
      area: {
        temp: {},
        checkedArray: []
      },
      areaOption: [],
      areaValues: [],
      checkedArray: []
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    // enabled: {}
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },
  created() {
    this.snEngineerChangeSave = this.permissions['snEngineerChangeSave']
    this.mySnEngineerChangeSave = this.permissions['mySnEngineerChangeSave']
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
  },
  watch: {
    picList1: {
      handler(newVal, oldVal) {
        this.tenant.engineerPic = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList2: {
      handler(newVal, oldVal) {
        this.tenant.engineerPidPic1 = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList3: {
      handler(newVal, oldVal) {
        this.tenant.engineerPidPic2 = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList4: {
      handler(newVal, oldVal) {
        this.tenant.certificateNoPic = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    fileList: {
      handler(newVal) {
        this.tenant.inoculateFile = uploadFileFormat(newVal)
      },
      deep: true
    }
  },
  mounted() {

    this.getData();
  },
  methods: {

    // 卡片事件
    //点击查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrlList = [file.url]
      this.dialogVisible = true;
      // console.log(fileList, "已上传文件")
    },

    closeImgViewer() {
      this.dialogVisible = false
    },

    submitChange(){//提交审核
      this.tenant.changeStat=2
      this.updateChangeStat(2)
    },

    auditChange(){//审核通过
      this.tenant.changeStat=5
      this.passTheAudit()
      /*this.updateChangeStat(5)*/
    },

    rejectChange(){//驳回
      this.tenant.changeStat=6
      this.updateChangeStat(6)
    },

    cancelChange(){//取消
      this.tenant.changeStat=99
      this.updateChangeStat(99)
    },
    updateChangeStat(changeStat){ //更新变更状态
      console.log("this.dataId",this.dataId)
      console.log("changeStat",changeStat)
      this.$http({
        url: api.snEngineerChange.updateChangeStatUrl,
        method: 'post',
        data: {
          changeId: this.dataId,
          changeStat : changeStat
        }
      }).then(res => {
        if (res.data.data){
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }
        this.reload()
      })
    },
    passTheAudit(){ // 审核通过
      this.$http({
        url: api.snEngineerChange.passTheAuditUrl,
        method: 'post',
        data: {
          id: this.dataId
        }
      }).then(res => {
        if (res.data.data){
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }
        this.reload()
      })
    },
    vacation(){
      this.tenant.postStat=3
      this.$message({
          message: '状态已改为休假中',
          type: 'success'
        });
      console.log(this.tenant.postStat,'this.tenant.postStat的值');
    },
    dimission(){
      this.tenant.postStat=9
      this.$message({
          message: '状态已改为离职',
          type: 'warning'
        });
      console.log(this.tenant.postStat,'this.tenant.postStat的值');
    },
    selectChangeEvent(data) {
      console.log('sakdjfksd',data)
      this.selectedData = data.records
    },

    buyChannelChangeEvent({records}) {
      this.tenant.selectedBuyChannelIdList = records.map(item => item.id)
      console.log('购买渠道选中', this.tenant.selectedBuyChannelIdList)
    },

    // 服务类型复选框
    serviceTypeSelectChangeEvent({records}) {
      // 拿到所有id
      let temp = records.map(item => item.id)

      // 获取有子类的父id
      let parentTemp = new Set()
      records.forEach(item => {
        if (item.parentId != 0) {
          parentTemp.add(item.parentId)
        }
      })

      // 去除有子类的父id
      let temp1= []
      temp.forEach(item => {
        if (!parentTemp.has(item)) {
          temp1.push(item)
        }
      })
      this.tenant.selectedServiceTypeIdList = temp1
      console.log('选中的服务类型id', temp1)
    },
    deleteData() {
      // this.$refs.editForm.validate(valid => {
      //   if (valid) {
          let temp = this.tenant.tableData1
          this.selectedData.forEach(item => {
            temp = temp.filter(item1 => item1.id != item.id)
          })
          this.tenant.tableData1 = temp
      //   }
      // })
    },
        // 服务品类复选框
        itemCategorySelectChangeEvent({records}) {
      // 拿到所有id
      let temp = records.map(item => item.id)

      // 获取有子类的父id
      let parentTemp = new Set()
      records.forEach(item => {
        if (item.parentId != 0) {
          parentTemp.add(item.parentId)
        }
      })

      // 去除有子类的父id
      let temp1= []
      temp.forEach(item => {
        if (!parentTemp.has(item)) {
          temp1.push(item)
        }
      })
      this.tenant.selectedItemCategoryIdList = temp1
      console.log('选中的服务类型id', temp1)
    },
       // 添加地区列表
       addAreaData() {
      if (this.area.temp.level < 3) {
        this.$message.warning('请至少选择到市级地址')
      } else {
        if (this.area.temp.level === 3 || this.area.temp.level === 4) {
          this.$http({
            url: api.basArea.getAreaPathDataUrl,
            method: 'post',
            data: {
              parentId: this.area.temp.id
            }
          }).then(res => {
            let tempArray = this.tenant.snSiteAreaList
            if (tempArray == null) {
              tempArray = []
            }
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.tenant.snSiteAreaList = this.uniqueArr(tempArray)
          })
        } else if (this.area.temp.level === 5) {
          this.$http({
            url: api.basArea.getAreaPathDataUrl,
            method: 'post',
            data: {
              areaId: this.area.temp.id,
            }
          }).then(res => {
            let tempArray = this.tenant.snSiteAreaList
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.tenant.snSiteAreaList = this.uniqueArr(tempArray)
          })
        }
      }
    },

    // 去重
    uniqueArr(arr) {
      let result = [];
      arr.forEach((item) => {
        if (!result.some(m => m.id === item.id)) {
          result.push(item);
        }
      });
      return result;
    },

    // 单个地区删除
    handleDelete(id) {
      console.log(id)
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.tenant.snSiteAreaList = this.tenant.snSiteAreaList.filter(item => item.id !== id)
      })
    },

    // 批量删除地区
      handleDeleteList() {
      console.log(this.checkedArray)
      console.log(this.checkedArray.length)
      if (this.checkedArray.length === 0) {
        this.$message.warning('请先勾选地址')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.checkedArray.forEach(item => {
            this.tenant.snSiteAreaList = this.tenant.snSiteAreaList.filter(item1 => item1.id !== item.id)
          })
          this.checkedArray = []
        })
      }
    },

    // 单个地址选中
    areaSelect(data) {
      console.log(data, '选中')
      if (data.checked) {
        this.checkedArray.push(data.row)
      } else {
        this.checkedArray = this.checkedArray.filter(item => item.id !== data.row.id)
      }
      console.log('askdfksd', this.checkedArray)
    },

    // 地址全选
    areaSelectAll(selection) {
      console.log(selection)
      this.checkedArray = []
      let records = selection.records
      records.forEach(item => {
        this.checkedArray.push(item)
      })
      console.log(this.checkedArray.length)
    },

    // 地址三级联动
    handleChange1() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.area.temp = {
        id: areaNode[0].value,
        level: areaNode[0].level
      }
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    cascaderLazyLoad1(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.data || {};

        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },
    inspection() {
      if (this.tenant.engineerMobile) {
        this.$http({
          url: api.snSiteEngineer.inspectionUrl,
          method: 'post',
          data: {
            value: this.tenant.engineerMobile,
            id: this.tenant.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("手机号码已存在，请重新输入")
            this.tenant.engineerMobile = null
          }
        })
      }
    },


    commitSelectedRow(data,isEdit) {
      this.tenant.siteId = data.id
      this.tenant.siteName = data.name
      console.log('获取网点id', data.id)
      this.$http({
        url: api.snUser.getSelectDimensionalityUrl,
        method: 'post',
        data: {id:data.id}
      }).then(res => {
        console.log('获取网点服务品类/服务类型/服务区域/服务渠道详情', res.data.data)

        this.tenant.serviceTypeList = res.data.data.selectServiceType
        this.tenant.itemCategoryList = res.data.data.selectCategory
        this.tenant.buyChannelList = res.data.data.selectBuyChannel
        if (data.type !== 'change'){
          this.tenant.snSiteAreaList = res.data.data.selectArea
        }
        /*this.tenant.snSiteAreaList = res.data.data.selectArea*/

        if (!isEdit){ // 点击编辑/新增进来后,每次重新选择网点的时候需要清空之前选择的维度数据
          this.tenant.selectedServiceTypeIdList = []
          this.tenant.selectedItemCategoryIdList = []
          this.tenant.selectedBuyChannelIdList = []
          /*this.tenant.snSiteAreaList = []*/
        }else{ //以下逻辑为 如果网点的维度数据已经更新 但当前工程师对应的网点的勾选维度数据是旧数据，需要用工程师旧的数据与网点新的数据做筛选，不存在的则剔除
          let allItemList = this.tenant.itemCategoryList.map(item => (item.id))
          this.tenant.selectedItemCategoryIdList = allItemList.filter(item => this.tenant.selectedItemCategoryIdList.indexOf(item) !== -1)

          let allServiceTypeList = this.tenant.serviceTypeList.map(item => (item.id))
          this.tenant.selectedServiceTypeIdList = allServiceTypeList.filter(item => this.tenant.selectedServiceTypeIdList.indexOf(item) !== -1)

          let allBuyChannelList = this.tenant.buyChannelList.map(item => (item.id))
          this.tenant.selectedBuyChannelIdList = allBuyChannelList.filter(item => this.tenant.selectedBuyChannelIdList.indexOf(item) !== -1)
        }
        this.itemCategoryShow = false
        this.serviceTypeShow = false
        this.buyChannelShow = false
        setTimeout(() => {
          this.itemCategoryShow = true
          this.serviceTypeShow = true
          this.buyChannelShow = true
        }, 2)

      })
    },

    commitSelectedRow2(data){
      console.log("data",data.id);
      this.$http({
        url: api.snSiteEngineer.getDataByIdUrl,
        method: 'post',
        data: {id:data.id}
      }).then(res => {
        console.log('获取工程师详情', res.data.data)
        this.tenant = res.data.data
        this.tenant.engineerId = data.id
        this.tenant.selectedItemCategoryIdList = res.data.data.selectedItemCategoryIdList
        this.tenant.areaId = res.data.data.areaId
        this.tenant.basCustAddressList  = res.data.data.snSiteAddressDTOS
        this.picList1 = echoFileFormat(this.tenant.engineerPic)
        this.picList2 = echoFileFormat(this.tenant.engineerPidPic1)
        this.picList3 = echoFileFormat(this.tenant.engineerPidPic2)
        this.picList4 = echoFileFormat(this.tenant.certificateNoPic)
        this.echoAddress()
        this.tenant.id = '';

        let id = {
          id: this.tenant.siteId,
          name : this.tenant.siteName,
          type : 'change'
        }
        this.commitSelectedRow(id,true)

        this.itemCategoryShow = false
        this.serviceTypeShow = false
        this.buyChannelShow = false
        setTimeout(() => {
          this.itemCategoryShow = true
          this.serviceTypeShow = true
          this.buyChannelShow = true
        }, 2)

      })
    },

    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList1 = echoFileFormat(res.data.url)
    },

    handleRemove2() {
      this.picList2 = []
    },
    handleSuccess2(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList2 = echoFileFormat(res.data.url)
    },

    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList3 = echoFileFormat(res.data.url)
    },

    handleRemove4() {
      this.picList4 = []
    },
    handleSuccess4(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList4 = echoFileFormat(res.data.url)
    },

    handleFileRemove() {
      this.fileList = []
    },
    handleFileSuccess(res, file, fileList) {
      console.log(res.data.url, "url")
      this.fileList = echoFileFormat(res.data.url)
    },


    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        /*this.changeType = 2;*/
        request({
          url: api.snEngineerChange.getDataByIdUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.tenant = response.data.data
          this.changeType = this.tenant.changeType
          this.changeStat = this.tenant.changeStat
          console.log("response",response)
          this.picList1 = echoFileFormat(this.tenant.engineerPic)
          this.picList2 = echoFileFormat(this.tenant.engineerPidPic1)
          this.picList3 = echoFileFormat(this.tenant.engineerPidPic2)
          this.picList4 = echoFileFormat(this.tenant.certificateNoPic)
          this.fileList = echoFileFormat(this.tenant.inoculateFile)
          this.echoAddress()
          let id = {
            id: this.tenant.siteId,
            name : this.tenant.siteName,
            type : 'change'
          }
          this.commitSelectedRow(id,this.isEdit)
          console.log("this.tenant",this.tenant)
        })
      } else {
        if (this.currentSiteData !== null){ //网点端
          let id = {
            id: this.currentSiteData.id,
            name : this.currentSiteData.userName
          }
          this.commitSelectedRow(id,false)
        }
      }
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (this.tenant.siteId === null) {
          this.$message.warning('请选择网点名称')
          return
        }
        if (this.tenant.selectedItemCategoryIdList.length === 0) {
          this.$message.warning('请选择服务品类')
          return
        }
        if (this.tenant.snSiteAreaList.length === 0) {
          this.$message.warning('请选择服务区域')
          return
        }
        if (this.tenant.selectedServiceTypeIdList.length === 0) {
          this.$message.warning('请选择服务类型')
          return
        }
        if (this.tenant.selectedBuyChannelIdList.length === 0) {
          this.$message.warning('请选择服务渠道')
          return
        }
        this.tenant.changeType = this.changeType;
        this.tenant.changeStat = this.changeStat;
        this.tenant.isNotChangeUpdate = true;

        console.log("valid",valid)
        console.log("保存数据",this.tenant)
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            if (this.changeStat === 6){ //驳回状态重新保存的时候把状态改为制单
              this.tenant.changeStat = 1;
              this.changeStat = 1;
            }
            var url = (this.isEdit ? api.snEngineerChange.updateDataUrl : api.snEngineerChange.addDataUrl);
            this.$http({
              url: url,
              method: `post`,
              data: this.tenant,
              isLoading: true,
            }).then(res => {
              this.$message.success('保存成功')
              this.reload()
              // this.$emit('editViewDataUpdate')
              // this.$baseReload()
            })
          });
        }
      });
    },






    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.tenant.engineerCountry = areaNode[0].label;
          this.tenant.engineerProvince = null;
          this.tenant.engineerCity = null;
          this.tenant.engineerCounty = null;
          this.tenant.engineerTown = null;
        } else if (areaNode[0].level == 2) {
          this.tenant.engineerProvince = areaNode[0].label;
          this.tenant.engineerCity = null;
          this.tenant.engineerCounty = null;
          this.tenant.engineerTown = null;
        } else if (areaNode[0].level == 3) {
          this.tenant.engineerCity = areaNode[0].label;
          this.tenant.engineerCounty = null;
          this.tenant.engineerTown = null;
        } else if (areaNode[0].level == 4) {
          this.tenant.engineerCounty = areaNode[0].label;
          this.tenant.engineerTown = null;
        } else if (areaNode[0].level == 5) {
          this.tenant.engineerTown = areaNode[0].label;
        }
        this.tenant.areaId = areaNode[0].value
      } else {
        this.tenant.areaId = null;
        this.tenant.engineerCounty = null;
        this.tenant.engineerProvince = null;
        this.tenant.engineerCity = null;
        this.tenant.engineerCounty = null;
        this.tenant.engineerTown = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },
    // 地址数据回显
    echoAddress() {
      if (this.tenant.areaId !== null && this.tenant.areaId !== '') {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: {id: this.tenant.areaId}
        }).then(res => {
          console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
    },


  },
};
</script>
<style lang="scss" scoped>
// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  position: absolute !important;
  bottom: -57px;
}
.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}
</style>
